import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";

import argumentDeveloper from "../assets/image/services/argumentDeveloper.svg";
import argumentTeam from "../assets/image/services/argumentTeam.svg";
// import argumentTeam from "../assets/image/services/argumentTeam.svg"
// import liIcon from "../li-icon.svg"
import seoData from "../seoData/StaffAugmentation.json"

const StaffAugmentation = () => {
  return (
    <>
      <SEO {...seoData} />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title="Hire Our Developer" page="Hire Our Developer" />

        <div className="section section-padding pb-0">
          <div className="container">
            <div className="row mb--40">
              <div className="col-lg-9">
                <h2 className="mb-3">Add experienced developers to your team, without the hiring cycle</h2>
                <p className="mb-3">
                  A lack of in-house skills is one of the most common reasons a
                  digital project stalls — not because the plan is wrong, but
                  because there's nobody available with the specific skill set
                  to execute it on schedule. Staff augmentation solves that
                  without the months a full-time hiring process usually takes.
                </p>
                <p className="mb-3">
                  We add our developers, testers, and designers directly into
                  your existing team and workflow. Our people typically bring
                  2-5 years of hands-on experience in their specialty, and we
                  back every placement with a 7-day risk-elimination period —
                  if a developer isn't the right fit within the first week, we
                  replace or release them, no long negotiation required.
                </p>
                <p>
                  <a href="mailto:info@itcodeinfotech.com">Reach us</a> or{" "}
                  <a href={process.env.PUBLIC_URL + "/contact"}>fill out our contact form</a>{" "}
                  — we'll discuss your requirements and find the best match
                  for your team.
                </p>
              </div>
            </div>
            <section id="augmentation-card" className="section-padding pb-0">
              <div className="row mb-5">
                <div className="col-lg-9">
                  <h2 className="p-3">Two ways to bring in extra hands</h2>
                </div>
                <div className="col-11 mx-auto col-lg-6">
                  <div className="augmentation-card">
                    <div className="d-flex gap-3 align-items-center">
                      <img src={argumentTeam} alt="Employ a committed team" />
                      <h3 className="mb-0">Employ a Committed Team</h3>
                    </div>
                    <p className="mt-2 mb-2">
                      For a larger build, you get a well-knit, professional
                      team of developers who work dedicatedly on your project
                      rather than splitting attention across other clients.
                      This covers skill gaps you don't have in-house, gives
                      you direct technical guidance and input throughout
                      development, reduces the overhead of running a hiring
                      process yourself, and keeps the team focused on your
                      strategic goals rather than a mixed backlog.
                    </p>
                  </div>
                </div>
                <div className="col-11 mx-auto col-lg-6 mt-3 mt-lg-0">
                  <div className="augmentation-card">
                    <div className="d-flex gap-3 align-items-center">
                      <img src={argumentDeveloper} alt="Employ a dedicated developer" />
                      <h3 className="mb-0">Employ a Dedicated Developer</h3>
                    </div>
                    <p className="mt-2 mb-2">
                      For a smaller gap — one specific skill, one extra pair
                      of hands — we place a single vetted developer or tester
                      directly into your workflow. They join your existing
                      tools, standups, and code review process, so the
                      overhead of bringing them on is closer to onboarding a
                      new hire than starting a separate vendor relationship.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row mb--40">
                <div className="col-lg-9">
                  <h2 className="mb-3">How the engagement actually works</h2>
                  <p>
                    We start with a short call to understand the gap — is it a
                    skill your team doesn't have, or capacity you're short on
                    for a defined period. From there we shortlist candidates
                    from our in-house bench rather than starting a cold search,
                    which is what keeps the turnaround fast. Once you've
                    approved a match, the developer joins your team's existing
                    communication channels, sprint cadence, and code review
                    process from day one — we don't ask you to adopt our
                    process, we fit into yours.
                  </p>
                </div>
              </div>
              <div className="py-4">
                <div className="section-header">
                  <h2 className="mb-3">What you get with every placement</h2>
                </div>
              </div>
              <div className="row">
                <div className="col-11 col-lg-9 mx-auto ms-lg-0">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title">1. Swift Access</h3>
                    <p className="mb-0 mt-3">
                      We keep 30+ in-house developers across different skill
                      sets, so you're choosing from people we already know the
                      capabilities of, not reviewing resumes from a cold
                      search. They work remotely, so there's no relocation or
                      office space to arrange, and a request typically turns
                      into a working developer on your project within days,
                      not weeks.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto me-lg-4 ms-lg-auto">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num2">
                      2. Flexible Pricing
                    </h3>
                    <p className="mb-0 mt-3">
                      Engagements are billed hourly, task-based, or as a fixed
                      monthly rate, whichever fits how you plan to use the
                      resource. A short, well-defined piece of work is often
                      cheaper task-based; an ongoing team extension usually
                      makes more sense on a monthly rate — we'll help you
                      figure out which applies before anything is agreed.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto ms-lg-0">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num3">
                      3. Long-Lasting Cooperation
                    </h3>
                    <p className="mb-0 mt-3">
                      Developers who stay engaged with a project build context
                      that's expensive to replace — they know the codebase's
                      quirks, the decisions behind past trade-offs, and where
                      the fragile parts are. We favor placements that continue
                      past the first deliverable specifically so that
                      knowledge doesn't walk out the door, and so you're not
                      re-explaining the project from scratch every few months.
                    </p>
                  </div>
                </div>
                <div className="col-11 col-lg-9 mt-4 mx-auto me-lg-4 ms-lg-auto">
                  <div className="augmentation-card">
                    <h3 className="augmentation-title num4">
                      4. Risk-Free Hiring
                    </h3>
                    <p className="mb-0 mt-3">
                      If a developer isn't the right fit for your team or your
                      requirements, the 7-day relaxation period from the start
                      of the engagement lets you request a replacement or end
                      the placement, no drawn-out process required. The goal
                      is that a bad match costs you a week, not a quarter.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row mt--60">
                <div className="col-lg-9">
                  <h2 className="mb-3">A worked example</h2>
                  <p>
                    A client running a mid-sized web platform needed a
                    backend developer for roughly three months to finish a
                    payments integration their in-house team didn't have
                    bandwidth for. Rather than running a full hire — job
                    posting, screening, onboarding — they described the gap
                    to us and we matched a developer from our existing bench
                    within days. The developer joined their sprint planning
                    and code review process directly, finished the
                    integration inside the original estimate, and the
                    engagement extended by another two months to help with a
                    related feature once the team saw how the work was
                    going. That's the shape most staff augmentation
                    engagements take: a specific, time-bound gap that either
                    closes on schedule or turns into an ongoing relationship
                    once trust is established.
                  </p>
                </div>
              </div>
            </section>
          </div>
          <ul className="list-unstyled shape-group-12">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
                alt="Circle"
              />
            </li>
          </ul>
        </div>

        <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
      </main>
    </>
  );
};

export default StaffAugmentation;
